<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { setToken, useUserStore } from '@/stores/user'
import { showToast } from '@/utils/toast'

defineProps<{ visible: boolean }>()
const emit = defineEmits<{ (e: 'close'): void }>()

const userStore = useUserStore()

// 构建 H5 popup-login 页面地址
const h5Origin = computed(() => {
  if (import.meta.env.DEV)
    return 'http://localhost:3001'
  return 'https://h5-fb-test.rocnovel.com'
})
const loginUrl = computed(() => `${h5Origin.value}/popup-login?from=${encodeURIComponent('Profile')}`)

// ── postMessage 处理 ────────────────────────────────────
function handleMessage(e: MessageEvent) {
  if (e.data?.source !== 'popup-login')
    return

  if (e.data?.type === 'LOGIN_SUCCESS' && e.data?.token) {
    setToken(e.data.token)
    userStore.fetchUserInfo()
    emit('close')
    if (e.data?.message)
      showToast(e.data.message)
  }
  else if (e.data?.type === 'LOGIN_ERROR') {
    if (e.data?.message)
      showToast(e.data.message)
  }
}

onMounted(() => {
  window.addEventListener('message', handleMessage)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage)
})
</script>

<template>
  <Teleport to="body">
    <div v-if="visible" class="popup-mask" @click.self="emit('close')">
      <div class="popup-panel">
        <button class="popup-close" @click="emit('close')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="#65686F" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </button>
        <iframe
          :src="loginUrl"
          class="login-iframe"
          frameborder="0"
          title="Sign In"
        />
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.popup-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.popup-panel {
  position: relative;
  width: 455px;
  height: 470px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 12px 32px 0px rgba(0, 0, 0, 0.16);
}

.popup-close {
  position: absolute;
  top: 8px;
  right: 20px;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s;
  z-index: 1;
}
.popup-close:hover {
  opacity: 1;
}

.login-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
